import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full mt-0 progress-bar"
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2 text-md"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Fetching Licenses", -1)
const _hoisted_4 = { class: "text-xs font-semibold text-gray-700 pl-1 pr-1" }
const _hoisted_5 = {
  key: 2,
  class: "w-fit relative inline-flex items-center gap-x-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "No license found.", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed, ref, watch, onBeforeMount, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useSchoolStore } from "@/stores/schoolStore";
import { useFilterStore } from "@/stores/filterStore";
import { useLicenseStore } from "@/stores/licenseStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolLicenseComponent',
  props: {
  showAllLicenses: {
    type: Boolean,
    default: false,
  },
  layoutType: {
    type: String,
    default: "vertical",
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();


const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const licenseStore = useLicenseStore();
const license = ref(licenseStore.getLicense);

const isStudentView = computed(() => route.path === "/main/students");
const isArchiveView = computed(
  () => route.path === "/main/internal-achive"
);
const layoutIsHorizontal = computed(() => props.layoutType === "horizontal");
const hasLicense = computed(() => license.value !== null);

const filteredProducts = computed(() => {
  if (props.showAllLicenses) {
    return license.value?.products || [];
  }
  const selectedSubject = filterStore.selectedFilters.subject;
  const products =
    license.value?.products?.filter(
      (product) => product?.product?.subject && product.product.subject == selectedSubject
    ) || [];
  return products;
});

const seatsUsedPercentage = (product :any) =>
  Math.round((product.seatsUsed / product.maxSeats) * 100);
const progressOver80 = (product :any) => seatsUsedPercentage(product) >= 80;
const progressMax = (product :any) => seatsUsedPercentage(product) >= 100;

watch(
  () => licenseStore.getLicense,
  (newLicense) => {
    license.value = newLicense;
  },
  { immediate: true }
);

onBeforeMount(async () => {
  const schoolId = schoolStore.getCurrentSchool?._id ?? "";
  const licenseSchool = licenseStore.getLicense?.school;
  if (!licenseStore.getLicense || licenseSchool !== schoolId) {
    await licenseStore.fetchLicenses(schoolId );
    license.value = licenseStore.getLicense;
  } else {
    license.value = licenseStore.getLicense;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (isStudentView.value || isArchiveView.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(licenseStore).loader.fetchingLicenses)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' }),
              _createTextVNode(),
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        (hasLicense.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({ 'flex flex-row justify-between': layoutIsHorizontal.value })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: product.product._id,
                  class: _normalizeClass(["flex flex-col", { 'mr-4': layoutIsHorizontal.value }])
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(product.title) + ": " + _toDisplayString(product.seatsUsed) + "/" + _toDisplayString(product.maxSeats), 1),
                  _createVNode(_component_ProgressBar, {
                    class: _normalizeClass({
            'progress-orange': progressOver80(product),
            'progress-red': progressMax(product),
          }),
                    value: seatsUsedPercentage(product)
                  }, null, 8, ["class", "value"])
                ], 2))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        (!hasLicense.value && !_unref(licenseStore).loader.fetchingLicenses)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})